import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'
import toast from 'react-hot-toast'

const ADMIN_EMAIL = 'andersonmelies@gmail.com'
const ADMIN_SENHA = 'Cifras@2026'

const PLANOS = [
  { valor: 'free',    label: 'Gratuito', cor: '#888',    bg: 'rgba(136,136,136,0.15)', preco: 0     },
  { valor: 'solo',    label: 'Solo',     cor: '#00CFFF', bg: 'rgba(0,207,255,0.15)',   preco: 9.90  },
  { valor: 'musico',  label: 'Músico',   cor: '#FF8C00', bg: 'rgba(255,140,0,0.15)',   preco: 24.90 },
  { valor: 'maestro', label: 'Maestro',  cor: '#a855f7', bg: 'rgba(168,85,247,0.15)',  preco: 39.90 },
]

const S = {
  card: { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 12, padding: '20px 24px' },
  th:   { fontSize: 11, color: '#888', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 },
  row:  { borderBottom: '1px solid rgba(255,255,255,0.05)', alignItems: 'center' },
  btn:  (cor) => ({ background: `${cor}18`, border: `1px solid ${cor}44`, color: cor, borderRadius: 7, padding: '4px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }),
}

function BadgePlano({ plano }) {
  const p = PLANOS.find(x => x.valor === plano) || PLANOS[0]
  return (
    <span style={{ background: p.bg, color: p.cor, border: `1px solid ${p.cor}`, borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700, fontFamily: 'Montserrat,sans-serif', textTransform: 'uppercase', letterSpacing: 1 }}>
      {p.label}
    </span>
  )
}

function StatCard({ label, valor, cor, sub }) {
  return (
    <div style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid ${cor}33`, borderRadius: 12, padding: '16px 20px', textAlign: 'center' }}>
      <div style={{ fontSize: 28, fontWeight: 800, color: cor, fontFamily: 'Montserrat,sans-serif' }}>{valor}</div>
      <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{label}</div>
      {sub && <div style={{ fontSize: 11, color: '#555', marginTop: 2 }}>{sub}</div>}
    </div>
  )
}

function TelaLogin({ onLogin }) {
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState('')

  function tentar(e) {
    e.preventDefault()
    if (senha === ADMIN_SENHA) { sessionStorage.setItem('admin_auth', '1'); onLogin() }
    else { setErro('Senha incorreta'); setSenha('') }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#060f1e', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter,sans-serif' }}>
      <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(0,207,255,0.2)', borderRadius: 16, padding: '40px 36px', width: 340, textAlign: 'center' }}>
        <div style={{ fontFamily: 'Montserrat,sans-serif', fontWeight: 800, fontSize: 26, marginBottom: 4 }}>
          <span style={{ color: '#00CFFF' }}>CIFRAS</span><span style={{ color: '#FF8C00' }}>BAND</span>
        </div>
        <div style={{ color: '#888', fontSize: 13, marginBottom: 32 }}>Painel Administrativo</div>
        <form onSubmit={tentar}>
          <div style={{ marginBottom: 16, textAlign: 'left' }}>
            <label style={{ fontSize: 12, color: '#888', marginBottom: 6, display: 'block' }}>E-MAIL</label>
            <input value={ADMIN_EMAIL} readOnly style={{ width: '100%', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 14px', color: '#666', fontSize: 14, boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 24, textAlign: 'left' }}>
            <label style={{ fontSize: 12, color: '#888', marginBottom: 6, display: 'block' }}>SENHA</label>
            <input type="password" value={senha} onChange={e => { setSenha(e.target.value); setErro('') }}
              placeholder="Senha admin" autoFocus
              style={{ width: '100%', background: 'rgba(255,255,255,0.05)', border: `1px solid ${erro ? '#ff4444' : 'rgba(255,255,255,0.1)'}`, borderRadius: 8, padding: '10px 14px', color: '#f0f0f0', fontSize: 14, outline: 'none', boxSizing: 'border-box' }} />
            {erro && <div style={{ color: '#ff4444', fontSize: 12, marginTop: 6 }}>{erro}</div>}
          </div>
          <button type="submit" style={{ width: '100%', background: 'linear-gradient(90deg,#00CFFF,#0099cc)', border: 'none', borderRadius: 10, padding: 13, color: '#071629', fontSize: 15, fontWeight: 800, cursor: 'pointer' }}>
            Entrar
          </button>
        </form>
      </div>
    </div>
  )
}

export default function AdminPage() {
  const { user } = useAuth()
  const navigate = useNavigate()

  const [autenticado, setAutenticado]       = useState(() => sessionStorage.getItem('admin_auth') === '1')
  const [usuarios, setUsuarios]             = useState([])
  const [grupos, setGrupos]                 = useState([])
  const [busca, setBusca]                   = useState('')
  const [loading, setLoading]               = useState(true)
  const [loadingGrupos, setLoadingGrupos]   = useState(false)
  const [salvando, setSalvando]             = useState(null)
  const [stats, setStats]                   = useState({})
  const [filtroPlano, setFiltroPlano]       = useState('todos')
  const [filtroExpirando, setFiltroExpirando] = useState(false)
  const [editando, setEditando]             = useState(null)
  const [novoPlano, setNovoPlano]           = useState('')
  const [novaExpiracao, setNovaExpiracao]   = useState('')
  const [aba, setAba]                       = useState('dashboard')

  useEffect(() => {
    if (user && user.email !== ADMIN_EMAIL) { toast.error('Acesso negado.'); navigate('/grupos') }
  }, [user, navigate])

  const calcStats = useCallback((data) => {
    const s = { total: data.length }
    PLANOS.forEach(p => { s[p.valor] = data.filter(u => (u.plano || 'free') === p.valor).length })
    s.comStripe = data.filter(u => u.stripe_subscription_id).length
    s.classicLicenciado = data.filter(u => u.classic_licenciado).length
    const hoje = new Date()
    const em7 = new Date(hoje); em7.setDate(hoje.getDate() + 7)
    s.expirandoEm7 = data.filter(u => {
      if (!u.plano_expira_em) return false
      const exp = new Date(u.plano_expira_em)
      return exp >= hoje && exp <= em7
    }).length
    const semana = new Date(hoje); semana.setDate(hoje.getDate() - 7)
    s.novosSemana = data.filter(u => u.criado_em && new Date(u.criado_em) >= semana).length
    s.totalShowsMes = data.reduce((acc, u) => acc + (u.shows_usados_mes || 0), 0)
    return s
  }, [])

  const carregar = useCallback(async () => {
    setLoading(true)
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('id,nome,apelido,email,instrumento,plano,plano_expira_em,classic_licenciado,criado_em,avatar_url,stripe_customer_id,stripe_subscription_id,shows_usados_mes')
        .order('criado_em', { ascending: false })
      if (error) throw error
      setUsuarios(data || [])
      setStats(calcStats(data || []))
    } catch (e) {
      toast.error('Erro: ' + e.message)
    } finally {
      setLoading(false)
    }
  }, [calcStats])

  const carregarGrupos = useCallback(async () => {
    setLoadingGrupos(true)
    try {
      const { data, error } = await supabase
        .from('grupos')
        .select('id,nome,descricao,tipo,modulo,criado_em,criado_por,grupo_membros(count)')
        .order('criado_em', { ascending: false })
      if (error) throw error
      setGrupos(data || [])
    } catch (e) {
      toast.error('Erro grupos: ' + e.message)
    } finally {
      setLoadingGrupos(false)
    }
  }, [])

  useEffect(() => { if (autenticado) carregar() }, [autenticado, carregar])
  useEffect(() => { if (autenticado && aba === 'grupos' && grupos.length === 0) carregarGrupos() }, [autenticado, aba, grupos.length, carregarGrupos])

  async function chamarAPI(body) {
    const { data: { session } } = await supabase.auth.getSession()
    const token = session?.access_token
    if (!token) throw new Error('Sessão expirada. Faça login novamente.')
    const res = await fetch('/api/admin/update-plan', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body),
    })
    const json = await res.json()
    if (!res.ok) throw new Error(json.error || `Erro ${res.status}`)
    return json
  }

  async function alterarPlano(userId, plano, expiracao) {
    setSalvando(userId)
    try {
      const json = await chamarAPI({ userId, plano, expiracao: expiracao || null })
      toast.success('Plano atualizado!')
      setUsuarios(prev => prev.map(u => u.id === userId ? { ...u, ...json.updates } : u))
      setStats(calcStats(usuarios.map(u => u.id === userId ? { ...u, plano } : u)))
      setEditando(null)
    } catch (e) {
      toast.error('Erro: ' + e.message)
    } finally {
      setSalvando(null)
    }
  }

  async function toggleClassic(userId, atual) {
    setSalvando(userId + '_classic')
    try {
      await chamarAPI({ userId, classicLicenciado: !atual })
      toast.success(!atual ? 'Classic licenciado!' : 'Licença Classic removida')
      setUsuarios(prev => prev.map(u => u.id === userId ? { ...u, classic_licenciado: !atual } : u))
    } catch (e) {
      toast.error('Erro: ' + e.message)
    } finally {
      setSalvando(null)
    }
  }

  const mrr = PLANOS.filter(p => p.preco > 0).reduce((acc, p) => acc + (stats[p.valor] || 0) * p.preco, 0)
  const arr = mrr * 12

  const filtrados = usuarios.filter(u => {
    const t = busca.toLowerCase()
    const ok = !busca || (u.nome||'').toLowerCase().includes(t) || (u.email||'').toLowerCase().includes(t) || (u.apelido||'').toLowerCase().includes(t)
    const planOk = filtroPlano === 'todos' || (u.plano || 'free') === filtroPlano
    if (!ok || !planOk) return false
    if (filtroExpirando) {
      if (!u.plano_expira_em) return false
      const exp = new Date(u.plano_expira_em)
      const em7 = new Date(); em7.setDate(em7.getDate() + 7)
      return exp >= new Date() && exp <= em7
    }
    return true
  })

  if (!user || user.email !== ADMIN_EMAIL) return null
  if (!autenticado) return <TelaLogin onLogin={() => setAutenticado(true)} />

  const ABAS = [['dashboard','Dashboard'],['usuarios','Usuários'],['grupos','Grupos'],['financeiro','Financeiro']]

  return (
    <div style={{ minHeight: '100vh', background: '#060f1e', color: '#f0f0f0', fontFamily: 'Inter,sans-serif' }}>

      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg,#071629,#0a1f3a)', borderBottom: '1px solid rgba(0,207,255,0.2)', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <button onClick={() => navigate('/grupos')} style={{ background: 'none', border: 'none', color: '#00CFFF', cursor: 'pointer', fontSize: 20 }}>←</button>
        <div>
          <div style={{ fontFamily: 'Montserrat,sans-serif', fontWeight: 800, fontSize: 20 }}>
            <span style={{ color: '#00CFFF' }}>CIFRAS</span><span style={{ color: '#FF8C00' }}>BAND</span>
            <span style={{ color: '#888', fontWeight: 400, fontSize: 13, marginLeft: 8 }}>Admin</span>
          </div>
          <div style={{ fontSize: 11, color: '#888' }}>Painel de Administração</div>
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
          <button onClick={() => { carregar(); if (aba === 'grupos') carregarGrupos() }}
            style={{ background: 'rgba(0,207,255,0.1)', border: '1px solid rgba(0,207,255,0.3)', color: '#00CFFF', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 13 }}>
            ↻ Atualizar
          </button>
          <button onClick={() => { sessionStorage.removeItem('admin_auth'); setAutenticado(false) }}
            style={{ background: 'rgba(255,68,68,0.1)', border: '1px solid rgba(255,68,68,0.3)', color: '#ff4444', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 13 }}>
            Sair
          </button>
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px 16px' }}>

        {/* Abas */}
        <div style={{ display: 'flex', gap: 4, marginBottom: 24, borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          {ABAS.map(([id, label]) => (
            <button key={id} onClick={() => setAba(id)} style={{
              padding: '10px 18px', background: 'none', border: 'none', cursor: 'pointer',
              color: aba === id ? '#00CFFF' : '#888', fontWeight: aba === id ? 700 : 400,
              borderBottom: aba === id ? '2px solid #00CFFF' : '2px solid transparent',
              fontSize: 14, marginBottom: -1
            }}>{label}</button>
          ))}
        </div>

        {/* ─────────────────────────────── DASHBOARD ─────────────────────────────── */}
        {aba === 'dashboard' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

            {/* Alertas */}
            {stats.expirandoEm7 > 0 && (
              <div style={{ background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.4)', borderRadius: 12, padding: '12px 18px', display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 22 }}>⚠️</span>
                <div>
                  <div style={{ fontWeight: 700, color: '#f59e0b' }}>{stats.expirandoEm7} plano(s) expirando nos próximos 7 dias</div>
                  <div style={{ fontSize: 12, color: '#888' }}>Filtre por "Expirando em breve" na aba Usuários</div>
                </div>
              </div>
            )}

            {/* Stats principais */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(130px,1fr))', gap: 12 }}>
              <StatCard label="Total usuários" valor={stats.total || 0} cor="#f0f0f0" />
              <StatCard label="Gratuito" valor={stats.free || 0} cor="#888" />
              <StatCard label="Solo" valor={stats.solo || 0} cor="#00CFFF" sub={`R$${((stats.solo||0)*9.90).toFixed(0)}/mês`} />
              <StatCard label="Músico" valor={stats.musico || 0} cor="#FF8C00" sub={`R$${((stats.musico||0)*24.90).toFixed(0)}/mês`} />
              <StatCard label="Maestro" valor={stats.maestro || 0} cor="#a855f7" sub={`R$${((stats.maestro||0)*39.90).toFixed(0)}/mês`} />
              <StatCard label="MRR" valor={`R$${mrr.toFixed(0)}`} cor="#4ade80" />
              <StatCard label="ARR" valor={`R$${arr.toFixed(0)}`} cor="#22c55e" sub="Proj. anual" />
              <StatCard label="Novos esta semana" valor={stats.novosSemana || 0} cor="#60a5fa" />
            </div>

            {/* Cards secundários */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 12 }}>
              <div style={{ ...S.card, display: 'flex', alignItems: 'center', gap: 16 }}>
                <span style={{ fontSize: 36 }}>💳</span>
                <div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: '#4ade80' }}>{stats.comStripe || 0}</div>
                  <div style={{ fontSize: 13, color: '#888' }}>Assinaturas Stripe ativas</div>
                </div>
              </div>
              <div style={{ ...S.card, display: 'flex', alignItems: 'center', gap: 16 }}>
                <span style={{ fontSize: 36 }}>🎼</span>
                <div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: '#a855f7' }}>{stats.classicLicenciado || 0}</div>
                  <div style={{ fontSize: 13, color: '#888' }}>Licenças Classic ativas</div>
                </div>
              </div>
              <div style={{ ...S.card, display: 'flex', alignItems: 'center', gap: 16 }}>
                <span style={{ fontSize: 36 }}>🎸</span>
                <div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: '#f59e0b' }}>{stats.totalShowsMes || 0}</div>
                  <div style={{ fontSize: 13, color: '#888' }}>Shows iniciados este mês</div>
                </div>
              </div>
              <div style={{ ...S.card, display: 'flex', alignItems: 'center', gap: 16 }}>
                <span style={{ fontSize: 36 }}>⚠️</span>
                <div>
                  <div style={{ fontSize: 22, fontWeight: 800, color: '#f59e0b' }}>{stats.expirandoEm7 || 0}</div>
                  <div style={{ fontSize: 13, color: '#888' }}>Expirando em 7 dias</div>
                </div>
              </div>
            </div>

            {/* Últimos cadastros */}
            <div style={S.card}>
              <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 16 }}>Cadastros recentes</div>
              {loading ? (
                <div style={{ color: '#888', fontSize: 13 }}>Carregando...</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                  {usuarios.slice(0, 10).map(u => (
                    <div key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                      <div style={{ width: 32, height: 32, borderRadius: '50%', flexShrink: 0, background: u.avatar_url ? `url(${u.avatar_url}) center/cover` : 'linear-gradient(135deg,#00CFFF22,#FF8C0022)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, color: '#00CFFF', fontWeight: 700 }}>
                        {!u.avatar_url && (u.nome?.[0] || '?').toUpperCase()}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 14, fontWeight: 600 }}>{u.nome || '—'}</div>
                        <div style={{ fontSize: 11, color: '#888' }}>{u.email}</div>
                      </div>
                      <BadgePlano plano={u.plano || 'free'} />
                      <div style={{ fontSize: 11, color: '#666', minWidth: 80, textAlign: 'right' }}>
                        {u.criado_em ? new Date(u.criado_em).toLocaleDateString('pt-BR') : '—'}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ─────────────────────────────── USUÁRIOS ─────────────────────────────── */}
        {aba === 'usuarios' && (
          <>
            {/* Filtros */}
            <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
              <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por nome ou e-mail..."
                style={{ flex: 1, minWidth: 200, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 14px', color: '#f0f0f0', fontSize: 14, outline: 'none' }} />
              <select value={filtroPlano} onChange={e => setFiltroPlano(e.target.value)}
                style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 14px', color: '#f0f0f0', fontSize: 14, cursor: 'pointer' }}>
                <option value="todos">Todos os planos</option>
                {PLANOS.map(p => <option key={p.valor} value={p.valor}>{p.label}</option>)}
              </select>
              <button onClick={() => setFiltroExpirando(s => !s)}
                style={{ padding: '10px 14px', borderRadius: 8, border: `1px solid ${filtroExpirando ? '#f59e0b' : 'rgba(255,255,255,0.1)'}`, background: filtroExpirando ? 'rgba(245,158,11,0.15)' : 'rgba(255,255,255,0.05)', color: filtroExpirando ? '#f59e0b' : '#888', fontSize: 13, cursor: 'pointer', fontWeight: filtroExpirando ? 700 : 400 }}>
                ⚠ Expirando em 7d
              </button>
            </div>

            <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 12, overflow: 'hidden' }}>
              {/* Cabeçalho */}
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1fr 2fr 1fr', padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)', gap: 8 }}>
                {['Usuário','E-mail','Instrumento','Shows/mês','Plano / Expiração','Classic'].map(h => (
                  <span key={h} style={S.th}>{h}</span>
                ))}
              </div>

              {loading ? (
                <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Carregando...</div>
              ) : filtrados.length === 0 ? (
                <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Nenhum usuário encontrado.</div>
              ) : filtrados.map(u => (
                <div key={u.id}
                  style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1fr 2fr 1fr', padding: '12px 16px', ...S.row, gap: 8 }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.02)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  {/* Nome */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                    <div style={{ width: 32, height: 32, borderRadius: '50%', flexShrink: 0, background: u.avatar_url ? `url(${u.avatar_url}) center/cover` : 'linear-gradient(135deg,#00CFFF22,#FF8C0022)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, color: '#00CFFF', fontWeight: 700 }}>
                      {!u.avatar_url && (u.nome?.[0] || '?').toUpperCase()}
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.nome || '—'}</div>
                      {u.apelido && <div style={{ fontSize: 11, color: '#888' }}>@{u.apelido}</div>}
                    </div>
                  </div>

                  {/* Email */}
                  <div style={{ fontSize: 12, color: '#aaa', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', alignSelf: 'center' }}>{u.email || '—'}</div>

                  {/* Instrumento */}
                  <div style={{ fontSize: 12, color: '#aaa', alignSelf: 'center' }}>{u.instrumento || '—'}</div>

                  {/* Shows/mês */}
                  <div style={{ fontSize: 13, fontWeight: 600, color: (u.shows_usados_mes || 0) > 0 ? '#f59e0b' : '#555', alignSelf: 'center' }}>
                    {u.shows_usados_mes || 0}
                  </div>

                  {/* Plano / Edição */}
                  <div style={{ alignSelf: 'center' }}>
                    {editando === u.id ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                          <select value={novoPlano} onChange={e => setNovoPlano(e.target.value)}
                            style={{ background: '#0a1f3a', border: '1px solid rgba(0,207,255,0.4)', borderRadius: 6, padding: '4px 8px', color: '#f0f0f0', fontSize: 12, cursor: 'pointer' }}>
                            {PLANOS.map(p => <option key={p.valor} value={p.valor}>{p.label}</option>)}
                          </select>
                          <button onClick={() => alterarPlano(u.id, novoPlano, novaExpiracao)} disabled={salvando === u.id}
                            style={{ background: '#00CFFF', color: '#060f1e', border: 'none', borderRadius: 6, padding: '4px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                            {salvando === u.id ? '...' : 'Salvar'}
                          </button>
                          <button onClick={() => setEditando(null)}
                            style={{ background: 'rgba(255,255,255,0.1)', color: '#888', border: 'none', borderRadius: 6, padding: '4px 8px', fontSize: 12, cursor: 'pointer' }}>✕</button>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <label style={{ fontSize: 11, color: '#888', whiteSpace: 'nowrap' }}>Expira:</label>
                          <input type="date" value={novaExpiracao} onChange={e => setNovaExpiracao(e.target.value)}
                            style={{ background: '#0a1f3a', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 6, padding: '3px 6px', color: '#f0f0f0', fontSize: 11 }} />
                          {novaExpiracao && (
                            <button onClick={() => setNovaExpiracao('')} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 11 }}>✕</button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                        <BadgePlano plano={u.plano || 'free'} />
                        {u.stripe_subscription_id && <span title="Stripe ativo" style={{ fontSize: 14 }}>💳</span>}
                        {u.plano_expira_em && (
                          <span style={{ fontSize: 10, color: new Date(u.plano_expira_em) < new Date() ? '#ff4444' : '#f59e0b' }}>
                            {new Date(u.plano_expira_em) < new Date() ? '⚠ expirado' : `até ${new Date(u.plano_expira_em).toLocaleDateString('pt-BR')}`}
                          </span>
                        )}
                        <button onClick={() => { setEditando(u.id); setNovoPlano(u.plano || 'free'); setNovaExpiracao(u.plano_expira_em ? u.plano_expira_em.split('T')[0] : '') }}
                          style={{ background: 'none', border: 'none', color: '#555', cursor: 'pointer', fontSize: 14 }} title="Alterar plano">✏️</button>
                      </div>
                    )}
                  </div>

                  {/* Classic toggle */}
                  <div style={{ alignSelf: 'center' }}>
                    <button
                      onClick={() => toggleClassic(u.id, u.classic_licenciado)}
                      disabled={salvando === u.id + '_classic'}
                      title={u.classic_licenciado ? 'Remover licença Classic' : 'Licenciar Classic'}
                      style={{
                        background: u.classic_licenciado ? 'rgba(168,85,247,0.2)' : 'rgba(255,255,255,0.05)',
                        border: `1px solid ${u.classic_licenciado ? '#a855f7' : 'rgba(255,255,255,0.1)'}`,
                        color: u.classic_licenciado ? '#a855f7' : '#555',
                        borderRadius: 7, padding: '4px 8px', fontSize: 11, fontWeight: 700, cursor: 'pointer'
                      }}>
                      {salvando === u.id + '_classic' ? '...' : u.classic_licenciado ? '🎼 ON' : '— OFF'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 12, fontSize: 12, color: '#555', textAlign: 'right' }}>
              {filtrados.length} de {usuarios.length} usuários
            </div>
          </>
        )}

        {/* ─────────────────────────────── GRUPOS ─────────────────────────────── */}
        {aba === 'grupos' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: 15, fontWeight: 700 }}>{grupos.length} grupos cadastrados</div>
              <button onClick={carregarGrupos} style={{ background: 'rgba(0,207,255,0.1)', border: '1px solid rgba(0,207,255,0.3)', color: '#00CFFF', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 13 }}>
                ↻ Atualizar
              </button>
            </div>

            <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr 1fr 1fr 1fr', padding: '12px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)', gap: 8 }}>
                {['Nome do Grupo','Tipo','Módulo','Membros','Criado em'].map(h => (
                  <span key={h} style={S.th}>{h}</span>
                ))}
              </div>

              {loadingGrupos ? (
                <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Carregando grupos...</div>
              ) : grupos.length === 0 ? (
                <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Nenhum grupo encontrado.</div>
              ) : grupos.map(g => {
                const membros = g.grupo_membros?.[0]?.count ?? '—'
                const modulo = g.modulo || 'cifrasband'
                const modCor = modulo === 'classic' ? '#a855f7' : '#00CFFF'
                return (
                  <div key={g.id}
                    style={{ display: 'grid', gridTemplateColumns: '3fr 1fr 1fr 1fr 1fr', padding: '12px 16px', ...S.row, gap: 8 }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.02)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontSize: 14, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.nome}</div>
                      {g.descricao && <div style={{ fontSize: 11, color: '#888', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.descricao}</div>}
                    </div>
                    <div style={{ fontSize: 12, color: '#aaa', alignSelf: 'center' }}>{g.tipo || '—'}</div>
                    <div style={{ alignSelf: 'center' }}>
                      <span style={{ fontSize: 11, fontWeight: 700, color: modCor, background: `${modCor}18`, border: `1px solid ${modCor}44`, borderRadius: 20, padding: '2px 8px' }}>
                        {modulo}
                      </span>
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#4ade80', alignSelf: 'center' }}>{membros}</div>
                    <div style={{ fontSize: 12, color: '#666', alignSelf: 'center' }}>
                      {g.criado_em ? new Date(g.criado_em).toLocaleDateString('pt-BR') : '—'}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}

        {/* ─────────────────────────────── FINANCEIRO ─────────────────────────────── */}
        {aba === 'financeiro' && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

            {/* MRR / ARR destaque */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div style={{ background: 'rgba(74,222,128,0.08)', border: '1px solid rgba(74,222,128,0.3)', borderRadius: 12, padding: '20px 24px', textAlign: 'center' }}>
                <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>MRR (Mensal)</div>
                <div style={{ fontSize: 36, fontWeight: 800, color: '#4ade80', fontFamily: 'Montserrat,sans-serif' }}>R${mrr.toFixed(2).replace('.', ',')}</div>
                <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Receita Recorrente Mensal</div>
              </div>
              <div style={{ background: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.3)', borderRadius: 12, padding: '20px 24px', textAlign: 'center' }}>
                <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>ARR (Anual projetado)</div>
                <div style={{ fontSize: 36, fontWeight: 800, color: '#22c55e', fontFamily: 'Montserrat,sans-serif' }}>R${arr.toFixed(2).replace('.', ',')}</div>
                <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>MRR × 12</div>
              </div>
            </div>

            {/* Breakdown por plano */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 12 }}>
              {PLANOS.filter(p => p.preco > 0).map(p => {
                const qtd = stats[p.valor] || 0
                const receita = qtd * p.preco
                return (
                  <div key={p.valor} style={{ background: p.bg, border: `1px solid ${p.cor}44`, borderRadius: 12, padding: '20px 16px' }}>
                    <div style={{ color: p.cor, fontWeight: 800, fontSize: 16, fontFamily: 'Montserrat,sans-serif', marginBottom: 8 }}>{p.label}</div>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 4 }}>
                      <span style={{ fontSize: 32, fontWeight: 800 }}>{qtd}</span>
                      <span style={{ fontSize: 13, color: '#888' }}>usuários</span>
                    </div>
                    <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>R${p.preco.toFixed(2).replace('.', ',')} / mês</div>
                    <div style={{ fontSize: 15, color: '#4ade80', fontWeight: 700 }}>
                      MRR: R${receita.toFixed(2).replace('.', ',')}
                    </div>
                  </div>
                )
              })}
            </div>

            {/* Métricas adicionais */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 12 }}>
              <div style={S.card}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Ticket médio (pagantes)</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#f0f0f0' }}>
                  {(stats.solo || 0) + (stats.musico || 0) + (stats.maestro || 0) === 0
                    ? 'R$0,00'
                    : `R$${(mrr / ((stats.solo||0)+(stats.musico||0)+(stats.maestro||0))).toFixed(2).replace('.', ',')}`}
                </div>
              </div>
              <div style={S.card}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Taxa de conversão</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#f0f0f0' }}>
                  {stats.total > 0 ? (((stats.total - (stats.free || 0)) / stats.total) * 100).toFixed(1) : '0'}%
                </div>
                <div style={{ fontSize: 11, color: '#888' }}>Free → Pago</div>
              </div>
              <div style={S.card}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Com Stripe</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#f0f0f0' }}>{stats.comStripe || 0}</div>
                <div style={{ fontSize: 11, color: '#888' }}>assinaturas ativas</div>
              </div>
            </div>

            {/* Stripe config */}
            <div style={S.card}>
              <div style={{ fontWeight: 700, marginBottom: 4, fontSize: 15 }}>Configuração Stripe (Vercel Env Vars)</div>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 16 }}>Settings → Environment Variables no painel do Vercel</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {[
                  'STRIPE_SECRET_KEY',
                  'STRIPE_WEBHOOK_SECRET',
                  'STRIPE_PRICE_SOLO_MONTHLY','STRIPE_PRICE_SOLO_ANNUAL',
                  'STRIPE_PRICE_MUSICO_MONTHLY','STRIPE_PRICE_MUSICO_ANNUAL',
                  'STRIPE_PRICE_MAESTRO_MONTHLY','STRIPE_PRICE_MAESTRO_ANNUAL',
                  'SUPABASE_URL',
                  'SUPABASE_SERVICE_ROLE_KEY',
                  'APP_URL',
                ].map(key => (
                  <div key={key} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: 'rgba(0,0,0,0.3)', borderRadius: 8 }}>
                    <code style={{ color: '#00CFFF', fontSize: 12, flex: 1 }}>{key}</code>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 16, padding: '12px 16px', background: 'rgba(0,207,255,0.05)', borderRadius: 8, fontSize: 12, color: '#aaa', lineHeight: 1.8 }}>
                <strong style={{ color: '#f0f0f0' }}>Webhook URL:</strong><br />
                <code style={{ color: '#00CFFF' }}>https://cifrasband.com.br/api/stripe/webhook</code><br />
                <strong style={{ color: '#f0f0f0' }}>Eventos:</strong><br />
                checkout.session.completed · customer.subscription.updated · customer.subscription.deleted · invoice.payment_failed
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  )
}
